import HTTPRequest from '../controllers/httpRequest.js'
import secureStorage from '../controllers/secureStorage.js';
import reportUtils from './reportUtils';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import moment from 'moment';

var pos_documentCustomFormat = {
  async print(endPoint, docId){

    let xCustomPosition = 0
    let component_x = {}
    component_x.endPoint = endPoint
    const pos_document = await HTTPRequest.getRequest(component_x.endPoint + "pos_documents/" + docId, null);
    console.log(pos_document)

    // Load Access Cost/Price rights (system_module_id 123): 'Z' = cost, 'Y' = price.
    let accessCostPriceRights = []
    try {
      let accessCostPriceRightsRequest = await HTTPRequest.getRequest(component_x.endPoint + 'users/' + secureStorage.getItem("userId") + "/access_rights?system_module_id=123", null)
      if (accessCostPriceRightsRequest && accessCostPriceRightsRequest.access_rights && accessCostPriceRightsRequest.access_rights[123]) {
        accessCostPriceRights = accessCostPriceRightsRequest.access_rights[123]
      }
    } catch (e) {
      accessCostPriceRights = []
    }
    // POS document shows selling prices -> gated by the price right ('Y').
    let maskPrice = function(value){ return reportUtils.maskTools.maskValue(value, 'Y', accessCostPriceRights) }
  
    // init header values
    let siteId = pos_document.site_id;
    let siteName = pos_document.site_name;
    let terminalId = pos_document.terminal_id;
    let terminalName = pos_document.terminal_name;
    let transId = pos_document.trans_id.toString();
    let or = pos_document.invoice_no;
    let businessDate = moment(pos_document.business_date).format('D-MMM-YYYY') || '';
    let totalQty = pos_document.total_quantity;
    let netAmount =  Number(pos_document.amount_net_vat) + Number(pos_document.amount_net_non_vat) + Number(pos_document.amount_net_zero_rated);
        netAmount =  netAmount.toString();
    let vatAmount = pos_document.amount_tax;
    let totalWithVat = pos_document.amount_due;
    let transCode = ''

    // other details
    let cashierName = pos_document.cashier_name;
    let customerName = pos_document.customer_name;
    let bagger = pos_document.bagger_name;
    let salesman = pos_document.salesman_name;
    let createdAt = pos_document.created_at_formatted;
    let printDate = moment().format('lll') || '';
    let line_position = 195;
    let startY = 90;
    let userCode = secureStorage.getItem("userCode") || '';
    let fontSizeIncreaser =  0

    let pos_document_lines = pos_document.details_pos_document_lines
    let pos_document_payments = pos_document.details_pos_document_payments

    // get data
    let siteData = await HTTPRequest.getRequest(`${component_x.endPoint}sites/${siteId}` , null, null);

    // need to replace later on based on db save.
    const paperSize = "a4"
    const orientation = 'portrait'
    let doc = new jsPDF({ orientation: orientation, unit: 'mm', format: paperSize });

    if (pos_document.document_trans_code == 'REC' && pos_document.document_type_code == 'POS'){
        transCode = 'POS Returns'
    } else if (pos_document.document_trans_code == 'REL' && pos_document.document_type_code == 'POS'){
        transCode = 'POS Sales'
    } else {
        transCode = ''
    }
    // declare header style
    let hdStyles = { fontSize: 8 + fontSizeIncreaser }
    let paymentHeadStyles = {
        halign: 'center',
        valign: 'middle',
        fontSize: 8 + fontSizeIncreaser
    }

    // declare style
    let styles = { fontSize: 7 + fontSizeIncreaser }
    let paymentColumnStyles = { 
        0: {
                halign: 'center',
                cellWidth: 'auto'
        },
        1: {
                halign: 'center',
                cellWidth: 28
        },
        2: {
                halign: 'center',
                cellWidth: 25
        },
        3: {
                halign: 'center',
                cellWidth: 25
        },
        4: {
                halign: 'right',
                cellWidth: 'auto'
        },
        5: {
                halign: 'right',
                cellWidth: 'auto'
        },
        6: {
                halign: 'center',
                cellWidth: 'auto'
        },
        7: {
                halign: 'center',
                cellWidth: 'auto'
        },
        8: {
                halign: 'right',
                cellWidth: 'auto'
        },
     }

    // make a dynamic column width based on number of columns
    let default_column_no = 8
    let max_table_width = 180 // if portrait
    let col_width = max_table_width / default_column_no // column equal width

    let headerCustomPosition = 0

    let header_position = 130 + headerCustomPosition
    let value_position = 160

    //  logo/image
    let logobarter = document.getElementById('logobarter');
    doc.addImage(logobarter, "PNG", 15, 20, 20, 20);
    doc.setFontStyle("bold");
    doc.setFontSize(14 + fontSizeIncreaser);
    doc.text(siteName, 40, 25);

    //  header details
    doc.setFontSize(10 + fontSizeIncreaser);
    doc.setFontStyle("normal");
    doc.text(15, 50, 'Site:');
    doc.text(40, 50, siteName);
    
    doc.text(15, 55, 'Terminal:');
    doc.text(40, 55, terminalName);

    doc.setFontStyle("bold");
    doc.text(`POS Document - ${transCode}`, header_position, 25);
    doc.setFontSize(8 + fontSizeIncreaser);
    
    doc.setFontStyle("normal");
    doc.setFontSize(10 + fontSizeIncreaser);
    doc.text("Business Date:", header_position, 50);
    doc.text(businessDate, value_position, 50);

    doc.text("Trans Id:", header_position, 55);
    doc.text(transId, value_position, 55);
    let x_position = 60

    doc.text("OR/SI No.:", header_position, x_position);
    doc.text(or, value_position, x_position);

    doc.text("Total Quantity", header_position, x_position + 5);
    doc.text(totalQty, value_position, x_position + 5);

    doc.text("Net Amount:", header_position, x_position + 10);
    doc.text(netAmount, value_position, x_position + 10);

    doc.text("VAT Amount:", header_position, x_position + 15);
    doc.text(vatAmount, value_position, x_position + 15);

    doc.text("Total with VAT:", header_position, x_position + 20);
    doc.text(totalWithVat, value_position, x_position + 20);

  
 
    let line_headers = [];
    let line_headers_tmp = [];
    let payment_headers = [];
    let payment_headers_temp = [];

    line_headers_tmp.push(
      {content: 'Description', styles: {halign: 'center', valign: 'top'}},
      {content: 'Barcode', styles: {halign: 'center', valign: 'top'}},
      {content: 'Stock No', styles: {halign: 'center', valign: 'top'}},
      {content: 'Qty', styles: {halign: 'center', valign: 'top'}},
      {content: 'Price', styles: {halign: 'center', valign: 'top'}},
      {content: 'Net Price', styles: {halign: 'center', valign: 'top'}},
      {content: 'Discount', styles: {halign: 'center', valign: 'top'}},
      {content: 'Subtotal', styles: {halign: 'center', valign: 'top'}}
    );
    line_headers.push(line_headers_tmp)

    payment_headers_temp.push(
      {content: 'Payment Type', styles: {halign: 'center', valign: 'top'}},
      {content: 'Reference Code', styles: {halign: 'center', valign: 'top'}},
      {content: 'First Name', styles: {halign: 'center', valign: 'top'}},
      {content: 'Last Name', styles: {halign: 'center', valign: 'top'}},
      {content: 'Amount Tender', styles: {halign: 'center', valign: 'top'}},
      {content: 'Amount Paid', styles: {halign: 'center', valign: 'top'}},
      {content: 'Remarks', styles: {halign: 'center', valign: 'top'}},
      {content: 'Status', styles: {halign: 'center', valign: 'top'}},
      {content: 'Excess', styles: {halign: 'center', valign: 'top'}}
    );
    payment_headers.push(payment_headers_temp)

    // make last 5 column align to right -> pos_document_lines
    let newStyle = []
    let colStyles = {}
    for(let x=0; x < default_column_no; x++){
      newStyle[x] = {cellWidth: col_width}
      if (x > (default_column_no - 5)){
        Object.assign(newStyle[x], {halign: 'right'})
      } else {
        Object.assign(newStyle[x], {halign: 'center'})
      }

      Object.assign(colStyles, {[x]: newStyle[x]})
    }
    
    // init table details
    let reportData = []
    let detail = []
    let reportLine = {}
    let paymentData = []
    let paymentDetail = []
    let paymentReportLine = []

    let subtotal_qty = 0
    let subtotal_price = 0
    let subtotal_net_price = 0
    let subtotal_discount = 0
    let subtotal_ext = 0
    let subtotal_amount_tender = 0
    let subtotal_amount_paid = 0
    let subtotal_excess = 0

    let grand_qty = 0
    let grand_price = 0
    let grand_net_price = 0
    let grand_discount = 0
    let grand_subtotal = 0
    let grand_amount_tender = 0
    let grand_amount_paid = 0
    let grand_excess = 0

    var minus_height = 0

    // lines looping
    for(let i=0; i < pos_document_lines.length; i++){
      reportLine = pos_document_lines[i]
      grand_qty = grand_qty + Number(reportLine.quantity)
      grand_price = grand_price + Number(reportLine.price)
      grand_net_price = grand_net_price + Number(reportLine.net_price)
      grand_discount = grand_discount + Number(reportLine.discount)
      grand_subtotal = grand_subtotal + Number(reportLine.subtotal)

      detail = [
        reportLine.description,
        reportLine.barcode,
        reportLine.stock_no,
        this.convertToCurrency(Number(reportLine.quantity), 0),
        maskPrice(this.convertToCurrency(Number(reportLine.price), 2)),
        maskPrice(this.convertToCurrency(Number(reportLine.net_price), 2)),
        this.convertToCurrency(Number(reportLine.discount), 2),
        maskPrice(this.convertToCurrency(Number(reportLine.subtotal), 2)),
      ];

      reportData.push(Object.assign({}, detail))

      subtotal_qty = subtotal_qty + Number(reportLine.quantity)
      subtotal_price = subtotal_price + Number(reportLine.price)
      subtotal_net_price = subtotal_net_price + Number(reportLine.net_price)
      subtotal_discount = subtotal_discount + Number(reportLine.discount)
      subtotal_ext = subtotal_ext + Number(reportLine.subtotal)

      let current_grouper = ""
      let next_grouper = ""

      let sub_detail = []
     
      if(i == pos_document_lines.length-1){
        sub_detail = [
          "", "", "",
          this.convertToCurrency(Number(subtotal_qty), 0),
          maskPrice(this.convertToCurrency(Number(subtotal_price), 2)),
          maskPrice(this.convertToCurrency(Number(subtotal_net_price), 2)),
          this.convertToCurrency(Number(subtotal_discount), 2),
          maskPrice(this.convertToCurrency(Number(subtotal_ext), 2))
        ]
        reportData.push(Object.assign({}, ["rowLine"]))
        reportData.push(Object.assign({}, sub_detail))
      } else {
        // current_grouper = reportLine.color
        // next_grouper = pos_document_lines[i+1].color
        // if(current_grouper != next_grouper){
        //   sub_detail = [
        //     "   ", "", "", 
        //     "", "", reportLine.color, "",
        //     this.convertToCurrency(Number(subtotal_qty), 0), 
        //     "", "",
        //     this.convertToCurrency(Number(subtotal_ext), 2)
        //   ]
  
        //   reportData.push(Object.assign({}, sub_detail))

        //   subtotal_qty = 0
        //   subtotal_ext = 0
        // }
      }
    }

    doc.setFontStyle("bold");
    doc.setFontSize(10 + fontSizeIncreaser);
    doc.text(15, startY-3, 'POS Document Details');
    doc.line(15, startY, line_position, startY);

    doc.autoTable({
      startY: startY,
      head: line_headers,
      body: reportData,
      theme: 'plain',
      tableWidth: 'wrap',
      styles: styles,
      headStyles: hdStyles,
      columnStyles: colStyles,
      margin: { bottom: 30 },
      didParseCell: function(data) {
        if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
          data.cell.styles.fillColor = [0, 0, 0]
          data.cell.styles.fontSize = 0.15
          data.cell.styles.cellPadding = 0
        } else if (data.row.section == 'body' && (data.row.raw[0] == '   ')){
          data.cell.styles.fontStyle = 'bold'
        }
      },     
    });
 
    // payments details loop
    for(let i=0; i < pos_document_payments.length; i++){
      paymentReportLine = pos_document_payments[i]
      grand_amount_tender = grand_amount_tender + Number(paymentReportLine.amount_tender)
      grand_amount_paid = grand_amount_paid + Number(paymentReportLine.amount)
      let paymentExcess = Number(paymentReportLine.excess) || 0
      // Fallback: calculate excess from tender minus amount if excess is 0
      if (paymentExcess === 0 && Number(paymentReportLine.amount_tender) > Number(paymentReportLine.amount)) {
        paymentExcess = Number(paymentReportLine.amount_tender) - Number(paymentReportLine.amount)
      }
      grand_excess = grand_excess + paymentExcess

      paymentDetail = [
        paymentReportLine.type,
        paymentReportLine.reference_code,
        paymentReportLine.first_name,
        paymentReportLine.last_name,
        this.convertToCurrency(Number(paymentReportLine.amount_tender), 2),
        this.convertToCurrency(Number(paymentReportLine.amount), 2),
        paymentReportLine.remark,
        paymentReportLine.status,
        this.convertToCurrency(paymentExcess, 2),
      ];

      paymentData.push(Object.assign({}, paymentDetail))

      subtotal_amount_tender = subtotal_amount_tender + Number(paymentReportLine.amount_tender)
      subtotal_amount_paid = subtotal_amount_paid + Number(paymentReportLine.amount)
      subtotal_excess = subtotal_excess + paymentExcess

      let payment_sub_detail = []
      if(i == pos_document_payments.length-1){
        payment_sub_detail = [
          "", "", "", "",
          this.convertToCurrency(Number(subtotal_amount_tender), 2),
          this.convertToCurrency(Number(subtotal_amount_paid), 2),
          "", "",
          this.convertToCurrency(Number(subtotal_excess), 2),
        ]

        paymentData.push(Object.assign({}, ["rowLine"]))
        paymentData.push(Object.assign({}, payment_sub_detail))
      } else {
      }
    }

    startY = doc.lastAutoTable.finalY + 15
    // show the table only when pos_document_payments.length > 0
    if(pos_document_payments.length > 0){
      doc.setFontStyle("bold");
      doc.setFontSize(10 + fontSizeIncreaser);
      doc.text(15, startY-3, 'Payments');
      doc.setDrawColor(0);
      doc.line(15, startY, line_position+5, startY);

      doc.autoTable({
        startY: startY,
        head: payment_headers,
        body: paymentData,
        theme: 'plain',
        tableWidth: 'wrap',
        styles: styles,
        headStyles: paymentHeadStyles,
        columnStyles: paymentColumnStyles,
        margin: { bottom: 30 },
        didParseCell: function(data) {
          if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
              data.cell.styles.fillColor = [0, 0, 0]
              data.cell.styles.fontSize = 0.15
              data.cell.styles.cellPadding = 0
          } else if (data.row.section == 'body' && (data.row.raw[0] == '   ')){
            data.cell.styles.fontStyle = 'bold'
          }
        }
      });
    }

    let finalY = doc.lastAutoTable.finalY; 
    let dynamic_y = finalY + 15
    doc.setFontStyle("bold");
    doc.setFontSize(7 + fontSizeIncreaser);

    // totals
    doc.text(15, 238-minus_height, "Total Price:")
    doc.text(60, 238-minus_height, maskPrice(`${this.convertToCurrency(Number(grand_price), 2)}`), 'right')
    dynamic_y = dynamic_y + 4
    doc.text(15, 242-minus_height, "Total Net Price:")
    doc.text(60, 242-minus_height, maskPrice(`${this.convertToCurrency(Number(grand_net_price), 2)}`), 'right')
    dynamic_y = dynamic_y + 4
    doc.text(15, 246-minus_height, "Total Discount:")
    doc.text(60, 246-minus_height, `${this.convertToCurrency(Number(grand_discount), 2)}`, 'right')
    dynamic_y = dynamic_y + 4
    doc.text(15, 250-minus_height, "Subtotal:")
    doc.text(60, 250-minus_height, maskPrice(`${this.convertToCurrency(Number(grand_subtotal), 2)}`), 'right')

    // stamp
    doc.setFontStyle("normal");
    doc.setFontSize(6 + fontSizeIncreaser);
    doc.text("Noted By:", 75, 240-minus_height)
    doc.text("____________________________________", 95, 240-minus_height)
    doc.text("Verified By:", 75, 244-minus_height)
    doc.text("____________________________________", 95, 244-minus_height)
    doc.text("Approved By:", 75, 248-minus_height)
    doc.text("____________________________________", 95, 248-minus_height)

    // other details
    doc.setFontStyle("normal");
    doc.text("Cashier:", 15, 257-minus_height);
    doc.text(cashierName, 35 + xCustomPosition, 257-minus_height);
    doc.text("Customer:", 70, 257-minus_height);
    doc.text(customerName, 90 + xCustomPosition, 257-minus_height);
    doc.text("Bagger:", 15, 262-minus_height);
    doc.text(bagger, 35 + xCustomPosition, 262-minus_height);
    doc.text("Salesman:", 70, 262-minus_height);
    doc.text(salesman, 90 + xCustomPosition, 262-minus_height);

    // Footer
    doc.line(15, 265-minus_height, line_position, 265-minus_height);
    doc.text("Printed By:", 15, 270-minus_height);
    doc.text(userCode, 35 + xCustomPosition, 270-minus_height);
    doc.text("Created By:", 70, 270-minus_height);
    doc.text(cashierName, 90 + xCustomPosition, 270-minus_height);
    doc.text("Posted By:", 125, 270-minus_height);
    doc.text(cashierName, 145 + xCustomPosition, 270-minus_height);
    doc.text("Print Date:", 15, 275-minus_height);
    doc.text(printDate, 35 + xCustomPosition, 275-minus_height)
    doc.text("Post Date:", 15, 280-minus_height);
    doc.text(createdAt, 35 + xCustomPosition, 280-minus_height)

    // page
    let pageCount = doc.internal.getNumberOfPages();
    for(let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8 + fontSizeIncreaser);
        doc.text('Page ' + String(i) + ' of ' + String(pageCount), 180, 290);
    }

    window.open(URL.createObjectURL(doc.output("blob")))
  },

  convertToCurrency(num, scale){
    return num.toFixed(scale).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
  },

}

export default pos_documentCustomFormat;
